import { publicRoutePaths } from "@/routes/public.routes.config";
import { Link } from "react-router-dom";
import SeoHelmet from "@/components/SeoHelmet";
import seoConfig from "@/data/seo.config";
import ConsentManager from "@/modules/frontend/components/ConsentManager";

import { motion } from "framer-motion";

const Index = () => {

  const fadeUpVariant = {
    hidden: { opacity: 0, y: 20 },
    visible: (delay = 0) => ({
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, delay },
    }),
  };

  return (
    <section className="privacy-policy terms-and-condition-wraper">
      <SeoHelmet
        title={seoConfig.privacyPolicy.title}
        description={seoConfig.privacyPolicy.description}
        keywords={seoConfig.privacyPolicy.keywords}
        author={seoConfig.privacyPolicy.author}
      />
      {/* inner banner wrape START  */}
      <div className="inner-banner">
        <div className="container">
          <div className="content-wrape desk-hide">
            <motion.h2
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <span className="light">
                Privacy
              </span>&nbsp;
              <span className="blue">
                Policy
              </span>
            </motion.h2>
            <motion.p
              className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >Your privacy matters to us—here’s how we safeguard your data</motion.p>
          </div>
          {/* <div className="content-wrape">
            <h1>Privacy Policy</h1>
          </div> */}
        </div>
      </div>
      {/* inner banner wrape END  */}

      <div className="trem-of-service-wraper container">
        <div className=" inner-page-content-wrape">
          <div className="content-wrape mobile-show page-head ">
            <motion.h2 className="mobile-head-text animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >
              <span className="light">Privacy</span>&nbsp;
              <span className="blue-text"> Policy</span>
            </motion.h2>
            <motion.p className="animate-child"
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, amount: 0.2 }}
              custom={0.2}
              variants={fadeUpVariant}
            >Your privacy matters to us—here’s how we safeguard your data</motion.p>
          </div>
        </div>

        <p>
          <b>Effective Date:</b> 25 Jan 2025
        </p>
        <p>
          <b>Last Updated:</b> 2 Dec 2024
        </p>

        <p>
          Orex Trade World INC (“OrexTrade,” “we,” “us,” or “our”) operates the
          website{" "}
          <Link to={publicRoutePaths.HOME.path} title="www.orextrade.com">
            www.orextrade.com{" "}
          </Link>{" "}
          (the “Platform”). We value your privacy and are committed to
          protecting your personal data in accordance with applicable data
          protection laws, including the U.S. Privacy Act, GDPR (EU General Data
          Protection Regulation) and other international privacy standards.
        </p>
        <p>
          By using our Platform, you agree to this Privacy Policy and our Terms
          and Conditions.
        </p>
        <h2 className="head">1. Information We Collect</h2>
        <p>
          We collect the following types of information to provide and improve
          our services:
        </p>
        <h3>a. Information You Provide</h3>
        <ul>
          <li>
            <b>Account Information:</b> Name, email address, company name,
            country, phone number and other registration details.
          </li>
          <li>
            <b>Profile Information:</b> Business type (Buyer, Supplier or
            Logistics Partner), product categories, company description and
            trade preferences.
          </li>
          <li>
            <b>Business Verification Documents:</b> We may collect your{" "}
            <b>
              business registration certificate, tax identification certificate,
              import/export license
            </b>
            or other relevant business documents to verify your authenticity
            and eligibility to use the Platform.
          </li>
          <li>
            <b>Communication Data:</b> Messages, emails or other interactions
            with our support or trade partners through the Platform.
          </li>
        </ul>

        <h3>b. Information Automatically Collected</h3>
        <ul>
          <li>
            <b>Technical Data:</b> IP address, browser type, operating system,
            and device information.
          </li>
          <li>
            <b>Usage Data:</b> Pages visited, actions performed, date/time of
            access and referral sources.
          </li>
          <li>
            <b>Cookies and Tracking Technologies:</b> We use cookies and similar
            technologies to enhance your browsing experience and analyze site
            traffic.
          </li>
        </ul>

        <h2 className="head">2. How We Use Your Information</h2>
        <p>We use your information for the following purposes:</p>
        <ul>
          <li>To create and manage your OrexTrade account.</li>
          <li>
            To connect Buyers, Suppliers and Logistics Partners on our
            Platform.
          </li>
          <li>
            To verify Buyer and Supplier profiles through submitted business and
            tax documents.
          </li>
          <li>To provide customer support and respond to inquiries.</li>
          <li>To improve our Platform, services and user experience.</li>
          <li>
            To send service updates, promotional offers or important policy
            notices (you may opt out anytime).
          </li>
          <li>
            To comply with applicable laws and prevent fraud, abuse or
            unauthorized access.
          </li>
        </ul>

        <h2 className="head">3. How We Share Your Information</h2>
        <p>
          We do <b>not sell</b> your personal data. We may share your
          information only in the following cases:
        </p>
        <ul>
          <li>
            <b>With Verified Partners:</b> To connect you with verified Buyers,
            Suppliers or Logistics Partners.
          </li>
          <li>
            <b>Service Providers:</b> With trusted third-party vendors who
            assist with hosting, analytics or communication (bound by
            confidentiality agreements).
          </li>
          <li>
            <b>Legal Requirements:</b> When required by law, court order or
            government request.
          </li>
          <li>
            <b>Business Transfers:</b> In case of merger, acquisition or sale
            of assets, your data may be transferred to the new entity.
          </li>
        </ul>

        <h2 className="head">4. Payments</h2>
        <p>
          OrexTrade does not directly process or facilitate payments between Buyers, Suppliers or Logistics Partners.
        </p>
        <ul>
          <li>
            All payments between Buyers and Suppliers are handled{" "}
            <b>independently</b> between those parties.
          </li>
          <li>
            OrexTrade does not store, access or manage any payment details for
            user transactions.
          </li>
        </ul>

        <h2 className="head">5. Data Retention</h2>
        <p>
          We retain your information for as long as necessary to fulfill the
          purposes described in this Policy, comply with legal obligations,
          resolve disputes or enforce our agreements.
        </p>

        <h2 className="head">6. Your Rights (GDPR & Global Users)</h2>
        <p>
          If you are located in the{" "}
          <b>European Union (EU), United Kingdom (UK)</b> or other regions with
          data protection laws, you have the following rights:
        </p>

        <ul>
          <li>
            <b>Access:</b> Request a copy of your personal data.
          </li>
          <li>
            <b>Correction:</b> Request corrections to inaccurate or incomplete
            data.
          </li>
          <li>
            <b>Deletion:</b> Request deletion of your personal information
            (subject to legal obligations).
          </li>
          <li>
            <b>Restriction:</b> Request restriction of data processing.
          </li>
          <li>
            <b>Data Portability:</b> Receive your data in a structured,
            machine-readable format.
          </li>
          <li>
            <b>Withdraw Consent:</b> Withdraw consent to processing at any time.
          </li>
        </ul>
        <p>
          To exercise these rights, contact us at{" "}
          <a
            href={`mailto:${process.env.REACT_APP_PRIVACY_MAIL}`}
            title={process.env.REACT_APP_PRIVACY_MAIL}
          >
            {process.env.REACT_APP_PRIVACY_MAIL}
          </a>
          .
        </p>
        <h2 className="head">7. Data Security</h2>
        <p>
          We use industry-standard security measures, including SSL encryption,
          secure servers and limited access controls, to protect your
          information. However, no online platform is 100% secure and we cannot
          guarantee absolute protection against all cyber threats.
        </p>
        <h2 className="head">8. Cookies Policy</h2>
        <p>
          OrexTrade uses cookies to personalize content, analyze traffic and
          improve performance. You can manage or disable cookies in your browser
          settings. Certain features of the Platform may not function properly
          without cookies.
        </p>

        <h2 className="head">9. Children’s Privacy</h2>
        <p>
          OrexTrade does not knowingly collect or solicit personal information
          from minors under 18 years of age. If you believe we have
          inadvertently collected data from a minor, please contact us
          immediately for deletion.
        </p>

        <h2 className="head">10. International Data Transfers</h2>
        <p>
          As a global trade platform, your data may be transferred to and
          processed in countries outside your own. We take appropriate steps to
          ensure that your data remains protected under this Policy and
          applicable laws, including Standard Contractual Clauses (SCCs) for
          international transfers.
        </p>

        <h2 className="head">11. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Any changes will be
          posted on this page with an updated “Effective Date.” Continued use of
          the Platform after such updates constitutes acceptance of the revised
          Policy.
        </p>

        <h2 className="head">12. Contact Us</h2>
        <p>
          If you have questions or concerns about this Privacy Policy or your
          data, please contact us at:
        </p>

        <p>
          <b>Orex Trade World INC</b>
        </p>
        <ul>
          <li>
            <b>Email: </b>
            <a
              href={`mailto:${process.env.REACT_APP_PRIVACY_MAIL}`}
              title={process.env.REACT_APP_PRIVACY_MAIL}
            >
              {process.env.REACT_APP_PRIVACY_MAIL}
            </a>
          </li>
          <li>
            <b>Website: </b>{" "}
            <Link to={publicRoutePaths.HOME.path} title="www.orextrade.com">
              www.orextrade.com{" "}
            </Link>
          </li>
          <li>
            <b>Registered Office: </b> Milledgeville, GA, 31061-7076, USA.
          </li>
        </ul>
      </div>
      <ConsentManager data={""} />
    </section>
  );
};

export default Index;
